import {
  FaLaptopCode,
  FaNetworkWired,
  FaServer,
  FaTools,
} from "react-icons/fa";
import customITSolution from "./img/customITSolution.webp";
import ITMaintenance from "./img/ITMaintenance.webp";
import networkImg from "./img/network.webp";
import primeHardwareSupply from "./img/primeHardwareSupply.webp";
import classes from "./Section1.module.css";

export default function Section1() {
  const cards = [
    {
      icon: <FaNetworkWired />,
      title: "Networking Equipment Solutions",
      desc: "Routers, switches, and access points to ensure fast, secure, and reliable connectivity for your business IT systems.",
      image: networkImg,
    },
    {
      icon: <FaServer />,
      title: "IT Hardware Supply",
      desc: "High-performance servers, desktops, and laptops, both new and certified refurbished, for enterprise, SMB, and home office setups.",
      image: primeHardwareSupply,
    },
    {
      icon: <FaLaptopCode />,
      title: "Custom IT Solutions & Consulting",
      desc: "Tailored IT consulting to select, configure, and deploy the right hardware and solutions to meet your business goals.",
      image: customITSolution,
    },
    {
      icon: <FaTools />,
      title: "IT Hardware Maintenance & Support",
      desc: "Comprehensive maintenance and support services to maximize uptime, extend hardware lifecycle, and optimize performance.",
      image: ITMaintenance,
    },
  ];

  return (
    <div className={classes.section1Wrapper}>
      {/* Section Title */}
      <div className={classes.section1Header}>
        <h2>Comprehensive IT Hardware & Networking Solutions</h2>
        <p>
          Prime Cloud Systems provides end-to-end IT hardware and networking
          solutions for businesses, IT professionals, and home users. From
          high-performance servers and desktops to networking equipment, custom
          IT consulting, and full hardware maintenance, we ensure your
          infrastructure is optimized, secure, and reliable.
        </p>
      </div>

      {/* Cards Grid */}
      <div className={classes.section1Cards}>
        {cards.map((card, idx) => (
          <div className={classes.section1Card} key={idx}>
            {/* Background image */}
            <div
              className={classes.section1CardBg}
              style={{ backgroundImage: `url(${card.image})` }}
            ></div>

            {/* Overlay + Text */}
            <div className={classes.section1CardOverlay}>
              <div className={classes.section1CardIcon}>{card.icon}</div>
              <h4 className={classes.section1CardTitle}>{card.title}</h4>
              <p className={classes.section1CardDesc}>{card.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
